import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=87b2d058&"
import script from "./NotificationsView.vue?vue&type=script&lang=js&"
export * from "./NotificationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QList,QItem,QCard,QItemSection,QAvatar,QItemLabel,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QList,QItem,QCard,QItemSection,QAvatar,QItemLabel,QIcon})
